import React from 'react';
import { Link } from 'react-router-dom';
import { useI18n } from '../i18n/I18nContext';
import Footer from '../components/Footer';
import '../styles/Legal.css';

const UPDATED = '11.06.2026';

const content = {
  tr: {
    badge: 'Yasal',
    title: 'Kullanım Koşulları',
    updated: `Son güncelleme: ${UPDATED}`,
    intro: `ViTex hizmetlerini kullanmadan önce lütfen bu koşulları dikkatlice okuyunuz. Siteye erişim sağlayarak
    veya hesap oluşturarak bu koşulları kabul etmiş sayılırsınız.`,
    sections: [
      {
        title: '1. Hizmet Tanımı',
        body: `ViTex; video ve ses dosyalarını metne dönüştüren bir masaüstü uygulaması ile bu uygulamayı
        destekleyen bir web platformu sunmaktadır. Platform üzerinden abonelik satın alabilir, transkripsiyon
        geçmişinizi görüntüleyebilir ve hesabınızı yönetebilirsiniz.`,
      },
      {
        title: '2. Hesap Güvenliği',
        body: null,
        items: [
          'Hesabınızı yalnızca gerçek ve güncel bilgilerle oluşturmanız zorunludur.',
          'Şifrenizin gizliliğini korumak ve yetkisiz erişimleri derhal bildirmek sizin sorumluluğunuzdadır.',
          'Hesabınız üzerinden gerçekleştirilen tüm işlemlerden siz sorumlusunuz.',
          '18 yaşından küçük bireyler ViTex hizmetlerini kullanamaz.',
        ],
      },
      {
        title: '3. Abonelik ve Ödeme',
        body: null,
        items: [
          'Planlar dakika bazlıdır; satın alınan dakikalar belirtilen süre içinde kullanılmalıdır.',
          'Ödemeler Iyzico aracılığıyla güvenli biçimde işlenmektedir.',
          'Dijital içerik niteliğinde olduğundan, aktivasyon sonrası iade yapılmamaktadır. Teknik sorunlarda lütfen destek ekibimizle iletişime geçiniz.',
          'Fiyatlar Türk Lirası (TRY) olarak belirtilmiş olup KDV dahildir.',
        ],
      },
      {
        title: '4. Kabul Edilebilir Kullanım',
        body: `Hizmeti yalnızca yasal amaçlar doğrultusunda kullanabilirsiniz. Aşağıdaki eylemler kesinlikle yasaktır:`,
        items: [
          'Telif hakkı ihlali oluşturan içeriklerin transkript edilmesi.',
          'Hizmete yetkisiz erişim sağlamaya çalışmak.',
          'Başkalarının hesaplarını kullanmak veya taklit etmek.',
          'Hizmetin normal işleyişini aksatacak eylemler gerçekleştirmek.',
          'Transkripsiyon çıktılarını kötü amaçlı veya yasadışı faaliyetlerde kullanmak.',
        ],
      },
      {
        title: '5. URL ile İndirme Özelliği (Beta)',
        body: `Masaüstü uygulamasındaki URL ile indirme özelliği beta aşamasında olup yalnızca kişisel kullanım
        için sunulmaktadır. Bu özelliği kullanırken aşağıdaki koşulları kabul etmiş sayılırsınız:`,
        items: [
          'URL üzerinden indirme yaparken üçüncü taraf platformların (YouTube vb.) kullanım koşullarına ve geçerli telif hakkı mevzuatına uymak tamamen sizin sorumluluğunuzdadır.',
          'ViTex üçüncü taraf içerikleri barındırmaz, depolamaz veya yeniden dağıtmaz; indirme işlemleri tamamen sizin cihazınızda gerçekleştirilir.',
          'Bu özelliği yalnızca hakkına sahip olduğunuz veya kişisel kullanım kapsamında erişebildiğiniz içerikler için kullanabilirsiniz.',
          'ViTex bu özelliği dilediği zaman değiştirme, kısıtlama veya kaldırma hakkını saklı tutar.',
        ],
      },
      {
        title: '6. Fikri Mülkiyet',
        body: `ViTex markası, logosu, yazılımı ve tüm içerikleri ViTex'e aittir. Transkripsiyon çıktıları size
        aittir; ancak yazılımı kopyalamak, tersine mühendislik uygulamak veya dağıtmak yasaktır.`,
      },
      {
        title: '7. Sorumluluk Sınırlaması',
        body: `ViTex, transkripsiyon doğruluğunu makul ölçüde güvence altına almaya çalışmakla birlikte,
        sonuçların hatasız olacağını taahhüt etmemektedir. Hizmet kesintileri, veri kayıpları veya
        üçüncü taraf hizmetlerinden kaynaklanan zararlar için sorumluluk kabul edilmemektedir.
        Azami sorumluluk, son 12 ay içinde ödediğiniz toplam tutarla sınırlıdır.`,
      },
      {
        title: '8. Hesap Feshi',
        body: `Bu koşulları ihlal etmeniz durumunda hesabınız önceden bildirimde bulunulmaksızın askıya alınabilir
        veya silinebilir. Hesabınızı istediğiniz zaman destek ekibimize başvurarak kapatabilirsiniz.`,
      },
      {
        title: '9. Uygulanacak Hukuk',
        body: `Bu koşullar Türk hukukuna tabidir. Uyuşmazlıklarda İstanbul mahkemeleri yetkilidir.`,
      },
      {
        title: '10. Değişiklikler',
        body: `Koşulları güncelleme hakkımız saklıdır. Önemli değişiklikler e-posta ile bildirilecektir. Değişiklik
        sonrasında hizmeti kullanmaya devam etmeniz, güncellenmiş koşulları kabul ettiğiniz anlamına gelir.`,
      },
      {
        title: '11. İletişim',
        body: null,
        contact: { email: 'vitex.app@gmail.com' },
      },
    ],
  },
  en: {
    badge: 'Legal',
    title: 'Terms of Service',
    updated: `Last updated: ${UPDATED}`,
    intro: `Please read these Terms of Service carefully before using ViTex. By accessing the site or creating an
    account you agree to be bound by these terms.`,
    sections: [
      {
        title: '1. Service Description',
        body: `ViTex provides a desktop application for transcribing video and audio files, supported by a web
        platform where you can purchase subscriptions, view transcription history, and manage your account.`,
      },
      {
        title: '2. Account Security',
        body: null,
        items: [
          'You must provide accurate and current information when creating an account.',
          'You are responsible for keeping your password confidential and for reporting unauthorized access immediately.',
          'You are responsible for all activity that occurs under your account.',
          'ViTex services are not available to individuals under 18 years of age.',
        ],
      },
      {
        title: '3. Subscriptions and Payment',
        body: null,
        items: [
          'Plans are minute-based; purchased minutes must be used within the specified period.',
          'Payments are processed securely via Iyzico.',
          'As digital content, plans are non-refundable after activation. For technical issues, please contact support.',
          'Prices are quoted in Turkish Lira (TRY) inclusive of VAT.',
        ],
      },
      {
        title: '4. Acceptable Use',
        body: `You may use the service only for lawful purposes. The following are strictly prohibited:`,
        items: [
          'Transcribing content that infringes copyright.',
          'Attempting to gain unauthorized access to the service.',
          "Impersonating or using another user's account.",
          'Actions that disrupt the normal operation of the service.',
          'Using transcription output for malicious or illegal activities.',
        ],
      },
      {
        title: '5. URL Download Feature (Beta)',
        body: `The URL download feature in the desktop application is provided in beta and is intended for
        personal use only. By using this feature you agree to the following:`,
        items: [
          'You are solely responsible for complying with the terms of service of third-party platforms (YouTube, etc.) and applicable copyright law when downloading via URL.',
          'ViTex does not host, store, or redistribute third-party content; downloads are performed entirely on your own device.',
          'You may only use this feature for content you own the rights to or may lawfully access for personal use.',
          'ViTex reserves the right to modify, restrict, or remove this feature at any time.',
        ],
      },
      {
        title: '6. Intellectual Property',
        body: `The ViTex brand, logo, software, and all site content are owned by ViTex. Transcription output
        belongs to you; however, copying, reverse-engineering, or distributing the software is prohibited.`,
      },
      {
        title: '7. Limitation of Liability',
        body: `ViTex makes reasonable efforts to ensure transcription accuracy but does not guarantee error-free
        results. We accept no liability for service outages, data loss, or damages arising from third-party
        services. Maximum liability is limited to the total amount paid in the preceding 12 months.`,
      },
      {
        title: '8. Account Termination',
        body: `We may suspend or delete your account without prior notice if you breach these terms. You may
        close your account at any time by contacting our support team.`,
      },
      {
        title: '9. Governing Law',
        body: `These terms are governed by Turkish law. Disputes are subject to the exclusive jurisdiction of
        Istanbul courts.`,
      },
      {
        title: '10. Changes',
        body: `We reserve the right to update these terms. Material changes will be communicated by email. Continued
        use of the service after a change constitutes acceptance of the updated terms.`,
      },
      {
        title: '11. Contact',
        body: null,
        contact: { email: 'vitex.app@gmail.com' },
      },
    ],
  },
};

export default function TermsOfService() {
  const { lang, t } = useI18n();
  const c = content[lang] || content.tr;

  return (
    <div className="legal-page">
      <header className="legal-header">
        <div className="legal-header-inner">
          <Link to="/" className="legal-back-link">← {t('common.backToHome')}</Link>
          <span className="legal-header-title">{t('legal.terms')}</span>
        </div>
      </header>

      <main className="legal-content">
        <span className="legal-badge">{c.badge}</span>
        <h1 className="legal-title">{c.title}</h1>
        <p className="legal-meta">{c.updated}</p>

        <div className="legal-highlight-box">
          <p>{c.intro}</p>
        </div>

        {c.sections.map((s, i) => (
          <div className="legal-section" key={i}>
            <h2>{s.title}</h2>
            {s.body && <p>{s.body}</p>}
            {s.items && (
              <ul>
                {s.items.map((item, j) => <li key={j}>{item}</li>)}
              </ul>
            )}
            {s.contact && (
              <div className="legal-contact-box">
                <p><strong>E-posta / Email:</strong>{' '}
                  <a href={`mailto:${s.contact.email}`}>{s.contact.email}</a>
                </p>
              </div>
            )}
          </div>
        ))}
      </main>

      <Footer />
    </div>
  );
}
